export const formTypeFormatter = (
  isVehicleInfoAvailable: boolean,
  source: string,
  topicOfInterest: string,
  customRequestType: string | null,
) => {
  const isGenericForm = source === 'generic' || source === 'general';

  const genericTopic = isGenericForm && topicOfInterest ? `_${topicOfInterest}` : '';

  const vin = isVehicleInfoAvailable ? '_vin' : '';

  const requestType = source === 'military' ? 'military' : `${source}${genericTopic}${vin}`;

  if (customRequestType) return customRequestType.replace('-', '_');

  return requestType;
};
export default formTypeFormatter;
